import Invoices from '../features/invoices';

export const InvoicesPage = () => <Invoices />;
